<template>
    <div class="chat-bubble" :id="message.id">
        <div class="chat-bubble-text">
            <p v-html="formattedMessage"></p>
        </div>
        <div class="chat-bubble-date">
            <span class="datetime">
                {{ formatDate(message.created_at) }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['message'],
    computed: {
        formattedMessage() {
        // جایگزینی /n با <br> برای تبدیل به خط جدید
        return this.message.message_text ? this.message.message_text.replace(/\/n/g, '<br>') : '';
        },
    },
    methods: {
        formatDate(dateString) {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
        },
    },
}
</script>

<style scoped>
.chat-bubble {
    background-color: #a4d6d9;
    border-radius: 10px;
    padding: 10px 15px;
    margin: 10px 0;
    max-width: 70%;
    width: fit-content;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: break-word;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* متن از راست چین باشد */
    position: relative; /* برای قرار دادن تاریخ */
}

.chat-bubble-text {
    direction: rtl;
    color: #000;
    font-size: 16px;
    line-height: 1.5;
    text-align: right;
    margin: 0; /* حذف فاصله‌های اضافی */
}

.chat-bubble-date {
    font-size: 12px;
    color: #555;
    text-align: left;
    align-self: flex-end; /* تاریخ به چپ منتقل می‌شود */
    margin-top: -15px; /* کمی فاصله بین متن و تاریخ */
    margin-left: -10px; /* کمی فاصله بین متن و تاریخ */
}
</style>